import { Search, MessageSquare } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { fmtDate } from "@/lib/langs";

export const UsersTable = ({ users, query, setQuery, selected, onSelect, onToggle }) => (
  <div className="holo-panel" data-testid="admin-users-table">
    <div className="flex flex-col gap-3 border-b border-border p-4 md:flex-row md:items-center">
      <div className="eyebrow md:mr-auto">Registered users · {users.length}</div>
      <div className="relative">
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input className="field !h-10 !pl-9 md:w-64" placeholder="Search name or email" value={query.search}
          onChange={(e) => setQuery({ ...query, search: e.target.value })} data-testid="admin-search-users-input" />
      </div>
      <Select value={query.status} onValueChange={(v) => setQuery({ ...query, status: v })}>
        <SelectTrigger className="h-10 w-full rounded-none font-mono text-xs md:w-36" data-testid="admin-filter-status"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">ALL</SelectItem>
          <SelectItem value="active">ENABLED</SelectItem>
          <SelectItem value="disabled">DISABLED</SelectItem>
        </SelectContent>
      </Select>
      <Select value={query.sort} onValueChange={(v) => setQuery({ ...query, sort: v })}>
        <SelectTrigger className="h-10 w-full rounded-none font-mono text-xs md:w-44" data-testid="admin-sort-users"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="created_desc">NEWEST</SelectItem>
          <SelectItem value="created_asc">OLDEST</SelectItem>
          <SelectItem value="name">NAME A–Z</SelectItem>
          <SelectItem value="minutes">MOST MINUTES</SelectItem>
          <SelectItem value="last_login">LAST LOGIN</SelectItem>
        </SelectContent>
      </Select>
    </div>
    <div className="max-h-[520px] overflow-auto">
      <table className="w-full min-w-[640px] text-sm">
        <thead className="sticky top-0 bg-card">
          <tr className="mono-label text-left !text-[10px]">
            <th className="px-4 py-3 font-normal">User</th>
            <th className="px-4 py-3 font-normal">Minutes</th>
            <th className="px-4 py-3 font-normal">Last login</th>
            <th className="px-4 py-3 font-normal">Enabled</th>
            <th className="px-4 py-3 font-normal" />
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.user_id} onClick={() => onSelect(u)}
              className={`cursor-pointer border-t border-border transition-colors duration-200 hover:bg-muted/60 ${selected === u.user_id ? "bg-cyan-400/10" : ""}`}
              data-testid={`admin-user-row-${u.user_id}`}>
              <td className="px-4 py-3">
                <div className="flex items-center gap-2 font-medium">
                  <span className={`h-1.5 w-1.5 rounded-full ${u.online ? "bg-[color:var(--au-green)] shadow-[0_0_6px_var(--au-green)]" : "bg-muted-foreground/30"}`} />
                  {u.name}
                  {u.auth_provider === "google" && <span className="font-mono text-[9px] text-[color:var(--au-cyan)]">G</span>}
                </div>
                <div className="font-mono text-[11px] text-muted-foreground">{u.email}</div>
              </td>
              <td className="px-4 py-3 font-mono tabular-nums">{u.total_minutes}</td>
              <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{fmtDate(u.last_login)}</td>
              <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
                <Switch checked={!u.disabled} onCheckedChange={(v) => onToggle(u, !v)} data-testid={`admin-toggle-user-status-${u.user_id}`} />
              </td>
              <td className="px-4 py-3 text-right">
                <span className="relative inline-flex">
                  <MessageSquare size={15} className="text-muted-foreground" data-testid={`admin-open-support-chat-${u.user_id}`} />
                  {u.unread > 0 && <span className="absolute -right-2 -top-2 bg-[color:var(--au-red)] px-1 font-mono text-[9px] text-white">{u.unread}</span>}
                </span>
              </td>
            </tr>
          ))}
          {users.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center font-mono text-xs text-muted-foreground">NO USERS MATCH</td></tr>}
        </tbody>
      </table>
    </div>
  </div>
);
